import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["onMouseenter", "onMouseleave"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "tool fa fa-spinner fa-spin"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 2,
  class: "tool fa fa-spinner fa-spin"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "video-mask video-mask-black" }
const _hoisted_9 = {
  key: 0,
  class: "error-text"
}
const _hoisted_10 = { class: "video-mask video-mask-white" }

import { computed, reactive } from 'vue';
import type { LeftRight, MovieSearchState } from 'src/models/moviePlayer';
import { dtFormat } from 'src/lib/dateHelper';

interface Props {
  videoAreaWidth: string;
  videoAreaHeight: string;
  vidLeft: string;
  vidRight: string;
  activeVjsLrMap: Record<string, boolean>;
  isCurrentMovieReady: { left: boolean; right: boolean };
  movieSearch: MovieSearchState;
  isDownloadingScreenshot: boolean;
  isDownloadingMovieFile: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CompareModeVideos',
  props: {
    videoAreaWidth: {},
    videoAreaHeight: {},
    vidLeft: {},
    vidRight: {},
    activeVjsLrMap: {},
    isCurrentMovieReady: {},
    movieSearch: {},
    isDownloadingScreenshot: { type: Boolean },
    isDownloadingMovieFile: { type: Boolean }
  },
  emits: ["enter-fullscreen", "take-screenshot", "download-movie-file", "toolbox-area-click"],
  setup(__props: any) {

const props = __props;

const videoSlots = computed<Array<{ vid: string; lr: LeftRight }>>(() => [
  { vid: props.vidLeft, lr: 'left' },
  { vid: props.vidRight, lr: 'right' },
]);



// マウスホバー中のみツールボックスを表示する、この動画グリッド内に閉じた表示状態のため親stateには持たない
const showVideoToolbox = reactive<Record<string, boolean>>({});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "videos",
    style: _normalizeStyle({
      width: __props.videoAreaWidth,
      height: __props.videoAreaHeight,
    })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoSlots.value, ({vid, lr}) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "video",
        key: vid
      }, [
        _createElementVNode("video", {
          id: vid,
          class: "video-js vjs-fluid",
          crossorigin: "",
          playsinline: ""
        }, null, 8, _hoisted_1),
        _createElementVNode("div", {
          class: "glass-layer",
          onMouseenter: ($event: any) => (showVideoToolbox[vid] = true),
          onMouseleave: ($event: any) => (showVideoToolbox[vid] = false)
        }, [
          (__props.activeVjsLrMap[lr] && showVideoToolbox[vid])
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "video-toolbox",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toolbox-area-click', $event)))
              }, [
                _createElementVNode("div", {
                  class: "tool-icon-wrap",
                  onClick: ($event: any) => (_ctx.$emit('enter-fullscreen', lr))
                }, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "tool fas fa-search-plus fullscreen" }, null, -1)
                ]))], 8, _hoisted_3),
                (__props.isDownloadingScreenshot)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "tool-icon-wrap",
                      onClick: ($event: any) => (_ctx.$emit('take-screenshot', lr, vid))
                    }, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("i", { class: "tool fas fa-camera dl-image" }, null, -1),
                      _createElementVNode("i", { class: "fa fa-arrow-alt-circle-down mini-arrow" }, null, -1)
                    ]))], 8, _hoisted_5)),
                (__props.isDownloadingMovieFile)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: "tool-icon-wrap",
                      onClick: ($event: any) => (_ctx.$emit('download-movie-file', lr))
                    }, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("i", { class: "tool fas fa-file-video" }, null, -1),
                      _createElementVNode("i", { class: "fa fa-arrow-alt-circle-down mini-arrow" }, null, -1)
                    ]))], 8, _hoisted_7))
              ]))
            : _createCommentVNode("", true)
        ], 40, _hoisted_2),
        _withDirectives(_createElementVNode("div", {
          class: "corner-triangle-label",
          style: _normalizeStyle({opacity: lr === 'left' ? 1.0 : 0.5})
        }, null, 4), [
          [_vShow, __props.isCurrentMovieReady[lr]]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          (__props.movieSearch[lr].isResultEmpty)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(dtFormat)(__props.movieSearch[lr].params.dtFrom, 'yyyy/mm/dd')) + " 〜 " + _toDisplayString(_unref(dtFormat)(__props.movieSearch[lr].params.dtTo, 'yyyy/mm/dd')) + " の動画が見つかりませんでした ", 1))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, !__props.isCurrentMovieReady[lr]]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [
          [_vShow, __props.isCurrentMovieReady[lr] && !__props.activeVjsLrMap[lr]]
        ])
      ]))
    }), 128))
  ], 4))
}
}

})